import { Utils } from '@therealmanage/ciranet-ui-common';
import { Type } from 'class-transformer';
import { UserDashboardItemDetailResultDto } from './user-dashboard-item-detail-result-dto';

export class UserDashboardItemResultDto {
  title: string;
  code: string;
  status: 'OK' | 'INFO' | 'WARNING' | 'HIGH-ALERT';
  message: string;
  @Type(() => UserDashboardItemDetailResultDto)
  details: Array<UserDashboardItemDetailResultDto>;
  valueCaption: string;
  valueDataType:
    | 'CURRENCY'
    | 'COUNT'
    | 'NUMBER'
    | 'DATETIME'
    | 'STRING'
    | 'TEXT';
  valueVisible: boolean;

  // Transient
  value: string;
  html: string;
  columnFormat: any;
  activities: any[];
  hasIcon = true;
  childItem: UserDashboardItemResultDto;

  // Compact card properties
  compactMessage: string;
  compactLinkText: string;
  compactLinkId: string;
  compactIsOk = false;
  compactIsWarning = false;

  // Account balance past due properties
  isPastDue = false;
  pastDueMessage: string;

  // Account in collections properties
  isInCollections = false;
  collectionsMessage: string;
  collectionsContactInfo: string;

  //Account that has violations
  violations: Array<{
    category: string;
    date: Date;
    status: string;
    noticeUrl: string;
    noticeFileName: string;
  }> = [];

  // Architectural requests details for compact card
  architecturalRequests: Array<{
    category: string;
    requestedDate: Date;
    status: string;
  }> = [];

  // Documents details for compact card
  documents: Array<{
    type: string;
    effectiveDate: Date;
    fileName: string;
    fileUrl: string;
  }> = [];

  get isOk(): boolean {
    return this.status.toUpperCase() === 'OK';
  }

  get isInfo(): boolean {
    return this.status.toUpperCase() === 'INFO';
  }

  get isWarning(): boolean {
    return this.status.toUpperCase() === 'WARNING';
  }

  get isHighAlert(): boolean {
    return this.status.toUpperCase() === 'HIGH-ALERT';
  }

  get dataField(): string {
    if (Utils.isInList(this.valueDataType, ['STRING', 'TEXT'])) {
      return 'string';
    } else if (
      Utils.isInList(this.valueDataType, ['CURRENCY', 'COUNT', 'NUMBER'])
    ) {
      return 'number';
    } else if (Utils.equalsIgnoreCase(this.valueDataType, 'DATETIME')) {
      return 'datetime';
    }
    return '';
  }
}
